var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { HttpParams } from '@angular/common/http';
import { CustomFilterService } from 'path-shared/services/datasource/custom-filter-service';
import { Reflection } from 'path-shared/services/reflection/reflection';
var defaultSortParam = 'tipus';
var defaultSortDirection = 'desc';
var TiketFilterService = /** @class */ (function (_super) {
    __extends(TiketFilterService, _super);
    function TiketFilterService() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TiketFilterService.prototype.createFilterParams = function (filter, start, pageSize, sortField, sortDir) {
        return new HttpParams()
            .append('COD_TIPO', Reflection.hasValue(filter.COD_TIPO) ? filter.COD_TIPO : '')
            .append('DESC_TIPO', filter.DESC_TIPO ? filter.DESC_TIPO : '')
            .append('start', start.toString())
            .append('size', pageSize.toString())
            .append('sortparam', sortField === undefined ? defaultSortParam : sortField)
            .append('sortdir', sortDir === '' ? defaultSortDirection : sortDir);
    };
    TiketFilterService.prototype.createLoadParams = function (content) {
        return new HttpParams()
            .append('content', content ? content : '');
    };
    return TiketFilterService;
}(CustomFilterService));
export { TiketFilterService };
